<div id="app" class="app-container-contracts">
  <!-- Initial Contract List View -->
  <div v-if="!show_preview_modal">
    <nav class="nav-bar-contracts">
      <h1 class="nav-title-contracts">Documents</h1>
    </nav>

    <div class="contract-list-contracts">
      <div v-if="verification_data.length === 0" class="empty-state-contracts">
        <i class="bi bi-file-earmark-text fs-1 text-muted"></i>
        <h3>No documents yet</h3>
        <p>Upload your first contract to get started</p>
      </div>
      <div v-for="(row, index) in verification_data" :key="index"
        class="card shadow-sm rounded-5 border table-border-color">
        <div class="contract-header-contracts" @click="toggle_accordion(index)">
          <h3 class="contract-name-contracts">{{ row.name || "Unnamed Template" }}</h3>
          <div class="header-right-contracts">
            <div class="status-badge-contracts" :class="`status-${row.status.toLowerCase()}-contracts`">
              {{ row.status }}
            </div>
            <i class="bi bi-chevron-down accordion-icon-contracts" :class="{ 'open': accordion_open.get(index) }"></i>
          </div>
        </div>
        <div class="contract-content-contracts" :class="{ 'expanded': accordion_open.get(index) }">
          <div class="contract-meta-contracts">
            <div class="meta-item-contracts">
              <span class="meta-label-contracts">Type</span>
              <span class="meta-value-contracts">{{ row.file_type || "PDF" }}</span>
            </div>
            <div class="meta-item-contracts">
              <span class="meta-label-contracts">Uploaded</span>
              <span class="meta-value-contracts">{{ row.date_uploaded }}</span>
            </div>
            <div class="meta-item-contracts">
              <span class="meta-label-contracts">Modified</span>
              <span class="meta-value-contracts">{{ row.date_modified }}</span>
            </div>
            <div class="meta-item-contracts">
              <span class="meta-label-contracts">Version</span>
              <span class="meta-value-contracts">{{ row.version || "1" }}</span>
            </div>
          </div>
          <div class="contract-actions-contracts">
            <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow" @click="preview_contract(row)">
              Preview / Sign
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Preview/Sign View -->
  <div v-else>
    <!-- Navigation with breadcrumb -->
    <nav class="nav-bar-contracts">
      <h1 class="nav-title-contracts">Contract Review</h1>
      <div class="nav-breadcrumb-contracts">
        <span class="breadcrumb-back-contracts" @click="close_preview_modal">Back to Contracts</span>
        <div class="breadcrumb-separator-contracts"></div>
        <span>{{ preview_contract_data?.name || 'Document' }}</span>
      </div>
    </nav>
    <!-- Progress Indicator -->
    <div class="progress-container-contracts">
      <div class="progress-steps-contracts">
        <div class="step-contracts" :class="current_step >= 1 ? 'step-active-contracts' : 'step-inactive-contracts'">
          <div class="step-circle-contracts">
            <span v-if="current_step > 1"><i class="bi bi-check"></i></span>
            <span v-else>1</span>
          </div>
          <span class="step-label-contracts">Preview</span>
        </div>
        <div class="step-connector-contracts" :class="current_step > 1 ? 'active' : ''"></div>
        <div class="step-contracts"
          :class="current_step >= 2 ? (current_step > 2 ? 'step-completed-contracts' : 'step-active-contracts') : 'step-inactive-contracts'">
          <div class="step-circle-contracts">
            <span v-if="current_step > 2"><i class="bi bi-check"></i></span>
            <span v-else>2</span>
          </div>
          <span class="step-label-contracts">Signers</span>
        </div>
        <div class="step-connector-contracts" :class="current_step > 2 ? 'active' : ''"></div>
        <div class="step-contracts" :class="current_step >= 3 ? 'step-active-contracts' : 'step-inactive-contracts'">
          <div class="step-circle-contracts">3</div>
          <span class="step-label-contracts">Timeline</span>
        </div>
      </div>
    </div>
    <!-- Send Confirmation Alert -->
    <div v-if="show_send_confirmation" class="alert-contracts alert-info-contracts">
      <i class="bi bi-info-circle-fill"></i>
      <div>
        <strong>Confirm signer details</strong>
        <p class="alert-message-contracts">Review signer information below, then send to all signers</p>
      </div>
      <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow"
        @click="show_send_confirmation = false">×</button>
    </div>
    <!-- Document Preview Card -->
    <div class="card shadow-sm rounded-5 border table-border-color"
      :class="{ 'card-expanded-contracts': preview_section_open }">
      <div class="card-header-contracts" @click="toggle_preview_section">
        <div class="card-header-left-contracts">
          <div class="card-icon-contracts preview">
            <i class="bi bi-eye"></i>
          </div>
          <div>
            <div class="card-title-contracts">{{ is_signing_mode ? 'Sign Document' : 'Document Preview' }}</div>
            <div class="card-subtitle-contracts">{{ preview_contract_data?.name || 'Document' }}</div>
          </div>
        </div>
        <div class="card-header-right-contracts">
          <div class="btn-group-contracts" v-if="preview_section_open">
            <!-- Show Preview button when in signing mode -->
            <button v-if="is_signing_mode" class="btn btn-primary btn-sm rounded-3 text-xxs shadow"
              @click="preview_contract(preview_contract_data)">
              Preview
            </button>
            <!-- Show Sign button when in preview mode -->
            <button v-else class="btn btn-primary btn-sm rounded-3 text-xxs shadow"
              @click="sign_contract(preview_contract_data)">
              Sign
            </button>
            <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow" @click="download_contract"
              :disabled="is_downloading">
              <div v-if="is_downloading" class="spinner-contracts"></div>
              Download
            </button>
            <button v-if="!is_signing_mode" class="btn btn-primary btn-sm rounded-3 text-xxs shadow"
              @click="initiate_send_flow">
              Send
            </button>
          </div>
          <span class="card-chevron-contracts">›</span>
        </div>
      </div>
      <div class="card-content-contracts">
        <div class="card-body-contracts">
          <div class="document-viewer-contracts">
            <div v-if="docuseal_slug" id="document-container">
              <div v-if="is_loading_document && !document_loaded" class="document-placeholder-contracts">
                <div class="document-placeholder-content-contracts">
                  <div class="spinner-contracts"></div>
                  <p>{{ is_signing_mode ? 'Preparing document for signing...' : 'Loading document...' }}</p>
                </div>
              </div>
              <div v-show="document_loaded" id="docuseal-viewer" ref="docusealViewer"></div>
            </div>
            <div v-else class="document-placeholder-contracts">
              <i class="bi bi-file-earmark-text fs-1 text-muted"></i>
              <p>{{ is_signing_mode ? 'Document will load for signing' : 'Click to preview document' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Signers Card -->
    <div class="card shadow-sm rounded-5 border table-border-color"
      :class="{ 'card-expanded-contracts': signers_section_open }">
      <div class="card-header-contracts" @click="toggle_signers_section">
        <div class="card-header-left-contracts">
          <div class="card-icon-contracts signers">
            <i class="bi bi-people"></i>
          </div>
          <div>
            <div class="card-title-contracts">Signers</div>
            <div class="card-subtitle-contracts">{{ signers.length }} {{ signers.length === 1 ? 'signer' : 'signers' }}
            </div>
          </div>
        </div>
        <div class="card-header-right-contracts">
          <span class="card-chevron-contracts">›</span>
        </div>
      </div>
      <div class="card-content-contracts">
        <div class="card-body-contracts">
          <div v-for="signer in signers" :key="signer.id" class="signer-item-contracts">
            <div class="signer-avatar-contracts">
              {{ signer.name?.charAt(0) || '' }}{{ signer.surname?.charAt(0) || '' }}
            </div>
            <div class="signer-info-contracts">
              <div v-if="editing_signer_id === signer.id" class="signer-edit-form-contracts">
                <div class="signer-name-inputs-contracts">
                  <input v-model="temp_signer_name" class="form-control-contracts" placeholder="First name">
                  <input v-model="temp_signer_surname" class="form-control-contracts" placeholder="Last name">
                </div>
                <input v-model="temp_signer_email" type="email" class="form-control-contracts" placeholder="Email">
                <div class="btn-group-contracts">
                  <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow"
                    @click="save_signer_edits(signer)">Save</button>
                  <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow" @click="cancel_edit">Cancel</button>
                </div>
              </div>
              <div v-else>
                <div class="signer-name-contracts">{{ signer.name }} {{ signer.surname }}</div>
                <div class="signer-email-contracts">{{ signer.email }}</div>
              </div>
            </div>
            <div class="status-badge-contracts" :class="`status-${signer.status.toLowerCase()}-contracts`">
              {{ signer.status }}
            </div>
            <div class="btn-group-contracts" v-if="editing_signer_id !== signer.id">
              <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow" @click="open_edit_modal(signer)">
                Edit
              </button>
              <button v-if="signer.status.toLowerCase() === 'pending'"
                class="btn btn-primary btn-sm rounded-3 text-xxs shadow" @click="initiate_send_flow"
                :disabled="is_accepting">
                Send Contract
              </button>
              <button v-if="signer.status.toLowerCase() === 'pending'"
                class="btn btn-primary btn-sm rounded-3 text-xxs shadow" @click="open_decline_modal">
                Decline
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Timeline Card -->
    <div class="card shadow-sm rounded-5 border table-border-color"
      :class="{ 'card-expanded-contracts': timeline_section_open }">
      <div class="card-header-contracts" @click="toggle_timeline_section">
        <div class="card-header-left-contracts">
          <div class="card-icon-contracts timeline">
            <i class="bi bi-clock-history"></i>
          </div>
          <div>
            <div class="card-title-contracts">Timeline</div>
            <div class="card-subtitle-contracts">{{ timeline.length }} {{ timeline.length === 1 ? 'event' : 'events' }}
            </div>
          </div>
        </div>
        <div class="card-header-right-contracts">
          <span class="card-chevron-contracts">›</span>
        </div>
      </div>
      <div class="card-content-contracts">
        <div class="card-body-contracts">
          <div v-if="timeline.length > 0" class="timeline-contracts">
            <div v-for="(event, index) in timeline" :key="index" class="timeline-item-contracts">
              <div class="timeline-content-contracts">
                <div class="timeline-title-contracts">{{ event.event_type || 'Event' }}</div>
                <p class="timeline-description-contracts">{{ event.description || 'No description' }}</p>
                <div class="timeline-time-contracts">
                  {{ event.formatted_date || 'Unknown date' }}
                  <span v-if="event.user" class="timeline-user-contracts">• {{ event.user }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="empty-state-contracts">
            <i class="bi bi-clock-history fs-1 text-muted"></i>
            <p class="empty-state-message-contracts">No timeline events yet</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Decline Modal -->
<teleport to="body">
  <div v-if="decline_modal_visible" class="modal-overlay-contracts" @click="cancel_decline">
    <div class="modal-contracts" @click.stop>
      <div class="modal-header-contracts">
        <h2 class="modal-title-contracts">Decline Contract</h2>
        <button class="btn btn-primary btn-sm rounded-3 text-xxs shadow" @click="cancel_decline">×</button>
      </div>
      <div class="modal-body-contracts">
        <div class="form-group-contracts">
          <label class="form-label-contracts">Reason for declining</label>
          <textarea v-model="decline_reason" class="form-control-contracts"
            placeholder="Please provide a reason for declining..." :disabled="is_declining"></textarea>
        </div>
      </div>
      <div class="modal-footer-contracts">
        <button class="btn btn-primary-dark btn-sm text-xxs shadow-sm" @click="cancel_decline"
          :disabled="is_declining">Cancel</button>
        <button class="btn btn-primary-dark btn-sm text-xxs shadow-sm" @click="confirm_decline"
          :disabled="is_declining || !decline_reason.trim()">
          <div v-if="is_declining" class="spinner-contracts"></div>
          <span v-else>Decline Contract</span>
        </button>
      </div>
    </div>
  </div>
</teleport>
</div>